'use strict';
var events = {};
events.items = [];
events.$items = $('.events-list');
events.numbers = {
  count: {
    container: $('.js-events-count'),
    number: $('.js-events-count .number'),
    label: $('.js-events-count .label')
  },
  additional: $('.js-numbers-additional')
};
events.peopleFilterInput = $('#filter-people');
events.peopleFilterList = $('.filter-list.people');
events.dateFilterList = $('.filter-list.date');
events.dateFilter = {
  val: $('.filtered-date-val'),
  block: $('.filter-block.date'),
  drop: $('.js-clear-date-filter'),
  dropAlt: $('.js-clear-date-filter-alt'),
  close: $('.filter-block.date .close-select')
};
events.eventDatesFormatted = [];
eventDates.forEach(function (date) {
  events.eventDatesFormatted.push(moment(date.dateMark).format('ddd MMM DD YYYY'));
});

events.dateFilterInput = new Pikaday({
  field: document.getElementById('filter-date'),
  format: 'YYYY-MM-DD',
  position: 'bottom left',
  container: document.getElementById('filter-date-options'),
  events: events.eventDatesFormatted,
  onSelect: function () {
    if (da.currentScreenType === 'mobile') {
      $('.js-sort-list').animate({
        width: "toggle",
        height: "toggle"
      }, 250, 'swing', function () {
        $('body').toggleClass('filter-shown');
      });
    }
    $('.filter-options').hide();
    events.requestDate = this.toString();
    events.dateFilter.val.text(moment(this.toString()).format('MMM DD, YYYY'));
    events.dateFilter.block.addClass('active');
    $('.js-clear-all-filters').parent().show();
    events.dateFilter.drop.show();
    events.makeSearch();
  }
});

$('.js-mobile-show-calendar').on('click', function () {
  if (!$('html').hasClass('touch')) {
    $('#filter-date-options').show();
    events.dateFilterInput.show();
  }
});

events.peopleFilterInput.on('input', function () {
  var that = this;
  if (!da.clearAllFlag && window.searchLoader.ajax) window.searchLoader.ajax.abort();
  if (events.filterTimer) {
    clearTimeout(events.filterTimer);
  }
  events.filterTimer = setTimeout(function () {
    spiral.ajax({
      "url": "/search/suggestPeople?query=" + that.value,
      "data": {
        limit: 100 //100 people on event page at once
      },
      processAnswer: function (result) {
        da.clearAllFlag = false;
        if (!result.isSuccess || result.response.status !== 200) return;
        events.peopleFilterList.empty();
        for (var item in result.response.items) {
          events.peopleFilterList.append('<a href="#" class="' + (result.response.items[ item ][ "isVIP" ] == 1 ? "vip" : "") + '" data-is-vip="' + result.response.items[ item ][ "isVIP" ] + '" data-id="' + result.response.items[ item ][ "id" ] + '">' +
            result.response.items[ item ][ "publicName" ] + '</a></br>');
        }
        if (events.searchByPeople) { //IE fix
          events.searchByPeople = false;
          // return;
        }
        if (!that.value && events.requestPeople) {
          events.requestPeople = '';
          da.peopleFilter.name.text(da.peopleFilter.name.data('default'));
          da.peopleFilter.block.removeClass('active');
          events.makeSearch();
        }

        if (that.value) {
          events.requestPeople = that.value;
          da.peopleFilter.name.text(that.value);
          da.peopleFilter.block.addClass('active');
          $('.js-clear-all-filters').parent().show();
          events.makeSearch();
        }
      }
    });
  }, 1000);
});

events.tagFilterInput = $('#filter-tag');
events.tagFilterList = $('.filter-list.tag');
events.tagFilterInput.on('input', function () {
  var that = this;
  if (events.filterTimer) {
    clearTimeout(events.filterTimer);
  }
  events.filterTimer = setTimeout(function () {
    spiral.ajax({
      "url": "/search/suggestTags/events?query=" + that.value,
      data: {
        eventID: da.eventID
      },
      processAnswer: function (result) {
        if (!result.isSuccess || result.response.status !== 200) return;
        events.tagFilterList.empty();
        for (var item in result.response.items) {
          events.tagFilterList.append('<a href="#" class="" data-id="' + result.response.items[ item ].url + '">' +
            result.response.items[ item ].name + '</a></br>');
        }
        if (!that.value && events.requestTagId) {
          events.requestTagId = '';
          da.tagFilter.name.text(da.tagFilter.name.data('default'));
          da.tagFilter.block.removeClass('active');
          events.makeSearch();
        }

      }
    });
  }, 250);
});

events.getQueryVars = function () {
  var query = window.location.search.substring(1);
  var vars = query.split("&");
  var pair = [];
  for (var i = 0; i < vars.length; i++) {
    pair = vars[ i ].split("=");
    if (pair[ 0 ] == "people" && pair[ 1 ].length > 0) {
      events.requestPeople = pair[ 1 ];
      spiral.ajax({
        "url": "/search/person?query=" + events.requestPeople,
        processAnswer: function (result) {
          if (!result.isSuccess || result.response.status !== 200) return;
          events.peopleFilterInput.val(result.response.item ? result.response.item : events.requestPeople);
          da.peopleFilter.name.text(result.response.item ? result.response.item : events.requestPeople);
          da.peopleFilter.block.addClass('active');
          events.rctv.set('peopleFilterActive', true);
          $('.js-clear-all-filters').parent().show();
        }
      })
    }
    if (pair[ 0 ] == "sortBy" && pair[ 1 ].length > 0) {
      events.requestSortBy = pair[ 1 ];
      $('.js-sort-by-current').text($('a[data-sort-type=' + events.requestSortBy).text());

    }
    if (pair[ 0 ] == "date" && pair[ 1 ].length > 0) {
      events.requestDate = pair[ 1 ];
      events.dateFilterInput.setDate(moment(events.requestDate).format(), true);
      events.dateFilter.val.text(moment(events.requestDate.toString()).format('MMM DD, YYYY'));
      events.dateFilter.block.addClass('active');
      $('.js-clear-all-filters').parent().show();
    }
    if (pair[ 0 ] == "tag" && pair[ 1 ].length > 0) {
      events.requestTagId = pair[ 1 ];
      spiral.ajax({
        "url": "/search/tag?query=" + events.requestTagId + "&type=events",
        processAnswer: function (result) {
          if (!result.isSuccess || result.response.status !== 200) return;
          events.tagFilterInput.val(result.response.item);
        }
      })
    }
  }
};

events.combineTotalRequest = function () {
  (events.requestPeople || events.requestSortBy || events.requestDate || events.requestTagId) || (events.oneTimeCombined) ? events.searchQuery = "?" : events.searchQuery = "";
  if (events.requestPeople) {
    events.rctv.set('peopleFilterActive', true);
    events.searchQuery += 'people=' + events.requestPeople;
    if (events.requestSortBy || events.requestDate || events.requestTagId) {
      events.searchQuery += '&';
    }
  } else {
    events.rctv.set('peopleFilterActive', false);
  }
  if (events.requestSortBy) {
    events.searchQuery += 'sortBy=' + events.requestSortBy;
    if (events.requestDate || events.requestTagId) {
      events.searchQuery += '&';
    }

  }
  if (events.requestDate) {
    events.searchQuery += 'date=' + events.requestDate;
    if (events.requestTagId) {
      events.searchQuery += '&';
    }
  }
  if (events.requestTagId) {
    events.searchQuery += 'tag=' + events.requestTagId;
  }

  if (events.searchQuery === '?') {
    events.searchQuery = '';
  }
  history.replaceState(null, '', location.origin + location.pathname + events.searchQuery);
  (events.requestPeople || events.requestDate) ? events.numbers.additional.hide() : events.numbers.additional.show();
  events.oneTimeCombined = true;
};

events.oneTimeCombined = false;

$(document).on('click', '.filter-list.people a', function (e) {
  e.preventDefault();
  if (window.searchLoader.ajax) {
    window.searchLoader.ajax.abort();
  }
  events.peopleFilterInput.val(this.innerHTML);
  da.peopleFilter.name.text(this.innerHTML);
  da.peopleFilter.block.addClass('active');
  $('.js-clear-all-filters').parent().show();
  events.requestPeople = this.dataset.id;
  events.searchByPeople = true;
  events.makeSearch();
});

$(document).on('click touchend', '.filter-list.sort-by a', function (e) {
  e.preventDefault();
  if (window.searchLoader.ajax) {
    window.searchLoader.ajax.abort();
  }
  events.requestSortBy = this.dataset.sortType;
  events.makeSearch();
  $('.js-sort-by-current').text(this.innerHTML);
  $('.filter-options').hide();
});
$(document).on('click touchend', '.filter-list.tag a', function (e) {
  e.preventDefault();
  if (window.searchLoader.ajax) {
    window.searchLoader.ajax.abort();
  }
  events.requestTagId = this.dataset.id;
  events.tagFilterInput.val(this.innerHTML);
  $('.js-clear-all-filters').parent().show();
  events.makeSearch();
});
events.dateFilter.drop.on('click', function (e) {
  e.preventDefault();
  if (da.currentScreenType === 'mobile') {
    $('.js-sort-list').animate({
      width: "toggle",
      height: "toggle"
    }, 250, 'swing', function () {
      $('body').toggleClass('filter-shown');
    });
  }
  $(this).hide();
  $('#filter-date').val("").trigger('input');
  events.dateFilter.val.text(' ');
  events.dateFilter.val.append('<span>' + events.dateFilter.val.data('default') + '</span>');
  events.dateFilter.block.removeClass('active');
  events.dateFilterInput.gotoToday();
  events.dateFilterInput.setDate();
  events.requestDate = "";
  events.makeSearch();
  checkClearAllFilters();
});
events.dateFilter.dropAlt.on('click', function (e) {
  events.dateFilter.drop.trigger('click');
});

//to prevent flickering of clear-filter button when window is inactive
$(window).on('focus blur', function (e) {
  if (events.dateFilter.block.hasClass('active')) {
    if (e.type === "blur") {
      events.dateFilter.drop.hide();
      events.dateFilter.close.hide();
    } else {
      events.dateFilter.drop.show();
      events.dateFilter.close.show();
    }
  }
});

/* TEMPLATING */
events.rctv = new Ractive({
  el: events.$items,
  template: '#tpl-items',
  data: {
    peopleFilterActive: false
  }
});
var Search = function (container, url, query) {
  this.container = container;
  this.isFirstTime = true;
  this.ajax = null;
  this.url = url;
  this.query = query;
  this.init();
};

Search.prototype.init = function () {
  this.loader = new spiral.InfiniteScroll(this.container, window, 1000, this.getItems.bind(this));
  this.reset();
  this.getItems();
};

Search.prototype.reset = function () {
  this.offset = 0;
  this.isMoreDataAvailable = true;
};

Search.prototype.getItemsCallback = function (data) {
  var that = this;
  data = that.isFirstTime ? data : data.response;
  if (that.isFirstTime && !data.items.length) {
    that.loader.disable();
  }
  that.isFirstTime = false;
  that.render(data.items);
  that.offset += data.items.length;
  events.numbers.count.number.text(data.pagination.total);
  data.pagination.total === 1 ? events.numbers.count.label.text(events.numbers.count.label.data('sing')) : events.numbers.count.label.text(events.numbers.count.label.data('plur'));
  events.numbers.count.container.show();

  if (events.items.length >= data.pagination.total) {
    that.loader.disable();
  } else {
    that.loader.enable();
    that.loader.checkScroll();
  }
}

Search.prototype.getItems = function () {
  if (!this.isMoreDataAvailable) {
    console.warn("No more. But you try to load.");
    return;
  }
  this.loader.disable();
  var that = this;
  var data = { offset: this.offset };
  if (this.query) {
    data = spiral.tools.extend(data, this.query);
  }

  if (that.isFirstTime && window.firstEvents) {
    var staticResponse = {
      gallery: [],
      items: window.firstEvents.foundItems,
      pagination: {
        limit: window.firstEvents.limit,
        offset: window.firstEvents.offset,
        total: window.firstEvents.total
      }
    };
    that.getItemsCallback(staticResponse);
  } else {
    this.ajax = spiral.ajax({
      url: this.url,
      data: data,
      processAnswer: function (data) {
        that.getItemsCallback(data);
      }
    });
  }
};

Search.prototype.render = function (items) {
  if (events.rctv.get('peopleFilterActive')) {
    var resultsWidth = $('.js-events-list').width();

    items.forEach(function (event, index) {
      var currWidth = 0;
      var base = 240;
      var mobileAmount = 0;
      event.photosDetails = [];
      var cap = {
        width: 260,
        type: 'cap'
      };

      if (event.photos.length === 0) event.photos.push({ ratio: 0.75, thumbnailURL: event.thumbnailURL });

      event.photos.some(function (photo, index) {
        //on desktop add one photo more (not less!) then container's width and decrease them after with 'flex'.
        if (da.currentScreenType === 'desktop') {
          if (currWidth + photo.ratio * base - (event.photos[ index + 1 ] || photo).ratio * base <= resultsWidth) {
            event.photosDetails.push({
              'width': photo.ratio * base,
              'thumbnailURL': photo.thumbnailURL,
              'id': photo.id
            });
            currWidth += photo.ratio * base;
          }
        } else {
          if (mobileAmount < 5) {
            event.photosDetails.push({
              'width': photo.ratio * base,
              'thumbnailURL': photo.thumbnailURL,
              'id': photo.id
            });
          }
          mobileAmount += 1;
        }
        if (index > 20) return true; //in case of big events, 20 is enough
      });

      if (event.photosDetails.length && event.photos.length > event.photosDetails.length)
        event.photosDetails[ event.photosDetails.length - 1 ].last = true;

      if (event.photosDetails.length - 1 < 5) {
        var photoLength = event.photosDetails.length;
        for (var i = 1; i <= 5 - photoLength; i++) {
          event.photosDetails.push(cap)
        }
      }
    });
  }
  events.items = events.items.concat(items);
  var all = events.rctv.get('items');
  var currentLength = 0;
  var newLength = items.length;
  if (all) {
    currentLength = all.length;
    all.push.apply(all, items);
  } else {
    events.rctv.set('items', items);
  }
  spiral.lock.removeLock("spiral", events.$items[ 0 ]);

  //make dots at the end of title if it's long
  if (!events.rctv.get('peopleFilterActive')) {
    events.itemLineHeight = 0;
    if (!events.itemLineHeight) {
      if (document.getElementsByClassName("full")[ 0 ] == undefined) return;
      events.itemLineHeight = parseInt(window.getComputedStyle(document.getElementsByClassName("full")[ 0 ]).getPropertyValue("line-height"));
    }
    for (var i = currentLength; i < (currentLength + newLength); i++) {
      var node = events.rctv.nodes[ 'item_' + i ].getElementsByClassName('full');
      var height = node[ 0 ].offsetHeight / events.itemLineHeight;
      if (height > 4) {
        node[ 0 ].parentNode.classList.add('dots');
      }
      node[ 0 ].parentNode.classList.add('lines-' + height);
    }
  }
  (da.currentScreenType === 'desktop') ? $('.search-row').addClass('desktop') : $('.search-row').addClass('mobile');
};

events.makeSearch = function (onPageLoad) {
  onPageLoad = typeof onPageLoad !== 'undefined' ? onPageLoad : false;
  onPageLoad ? events.getQueryVars() : '';
  events.combineTotalRequest();
  if (onPageLoad) {
    window.searchLoader = new Search(events.$items[ 0 ], "/search/events" + events.searchQuery, { limit: 30 });
  } else {
    //events.$items.empty();
    events.items = [];
    events.rctv.set('items', events.items);
    window.searchLoader.url = "/search/events" + events.searchQuery;
    window.searchLoader.reset();
    window.searchLoader.getItems();
  }
};

events.makeSearch(true);
